import React from 'react';
import { Link } from 'react-router-dom';
import './ContinueWatching.css';
import goodwillHuntingImage from '../images/goodwillhunting.jpg';
import interstellarImage from '../images/interstellar.jpg';
import lotrImage from '../images/lotr.avif';

type ProfileType = 'recruiter' | 'developer' | 'stalker';

interface MoreLikeThisProps {
  profile: ProfileType;
}

const moreLikeThisConfig = {
  recruiter: [
    { title: "Contact Me", imgSrc: interstellarImage, link: "/contact-me" },
    { title: "Publications", imgSrc: goodwillHuntingImage, link: "/publications" },
    { title: "Recommendations", imgSrc: lotrImage, link: "/recommendations" },
  ],
  developer: [
    { title: "Contact Me", imgSrc: interstellarImage, link: "/contact-me" },
    { title: "Publications", imgSrc: goodwillHuntingImage, link: "/publications" },
    { title: "Recommendations", imgSrc: lotrImage, link: "/recommendations" },
  ],
  stalker: [
    { title: "Contact Me", imgSrc: interstellarImage, link: "/contact-me" },
    { title: "Publications", imgSrc: goodwillHuntingImage, link: "/publications" },
    { title: "Recommendations", imgSrc: lotrImage, link: "/recommendations" },
  ],
};

const MoreLikeThis: React.FC<MoreLikeThisProps> = ({ profile }) => {
  const items = moreLikeThisConfig[profile];

  return (
    <div className="continue-watching-row">
      <h2 className="row-title">More Like This</h2>
      <div className="card-row">
        {items.map((pick, index) => (
          <Link to={pick.link} key={index} className="pick-card">
            <img src={pick.imgSrc} alt={pick.title} className="pick-image" />
            <div className="overlay">
              <div className="pick-label">{pick.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MoreLikeThis;
